import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { isSystemAdmin } from '../../../services';
import { publisherPortalActions } from '../../../state/modules/publisher-portal';
import { currentUserSelector } from '../../../state/modules/user';
import Content from './../shared/publish-content/content';

const mapStateToProps = (state) => ({
  contentResult: state.publisherPortal.content.contentResult,
  isFetchingContent: state.publisherPortal.content.isFetching,
  isFetching: state.cpdCategorys.isFetching ||
    state.publisherPortal.content.isFetching ||
    state.publisherPortal.content.isLoadingMore,
  contentDetailsRoute: routes.publisherPortal.contentDetails,
  allowDelete: fp.overSome([isSystemAdmin])(currentUserSelector(state)),
  choosePublisher: true
});

const mapDispatchToProps = (dispatch) => ({
  loadMoreContent: bindActionCreators(publisherPortalActions.publisherPortal.content.loadMore, dispatch),
  getContent: bindActionCreators(publisherPortalActions.publisherPortal.content.get, dispatch),
  deleteContent: bindActionCreators(publisherPortalActions.publisherPortal.content.deleteContent, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(Content);


// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/content.js